module.exports = __webpack_public_path__ + "static/media/image-card-5.3480444c.png";